import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { BookingModal } from './BookingModal';
type BookingContextValue = {
  openBooking: () => void;
  closeBooking: () => void;
  isBookingOpen: boolean;
};
const BookingContext = createContext<BookingContextValue | null>(null);
export function BookingProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const openBooking = useCallback(() => setIsBookingOpen(true), []);
  const closeBooking = useCallback(() => setIsBookingOpen(false), []);
  const value = useMemo(() => ({
    openBooking,
    closeBooking,
    isBookingOpen
  }), [openBooking, closeBooking, isBookingOpen]);
  return <BookingContext.Provider value={value} data-id="element-61" data-mp="236ndsiefdvas">
      {children}
      <BookingModal open={isBookingOpen} onClose={closeBooking} data-id="element-62" data-mp="2h4k97bh57vnv" />
    </BookingContext.Provider>;
}
export function useBooking(): BookingContextValue {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
}